import { Component } from "react";
import "../../../assets/css/table.css";
import { withTranslation } from "react-i18next";
import LoadingV2 from "../LoadingV2/LoadingV2";

class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: 7,
        };
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
        if (this.props.handleChangePage) {
            this.props.handleChangePage(pageNumber);
        }
    };

    getVipNumber(item) {
        const listVip = {
            "F1": 1,
            "F2": 2,
            "F3": 3,
            "F4": 4,
            "F5": 5,
            "F6": 6,
            "F7": 7,
        };
        return listVip[item] || 0;
    }

    getVipNumber2(item) {
        const listVip = {
            "Vip 1": 1,
            "Vip 2": 2,
            "Vip 3": 3,
            "Vip 4": 4,
            "Vip 5": 5,
            "Vip 6": 6,
            "Vip 7": 7,
        };
        return listVip[item] || 0;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.totalRecord !== this.props.totalRecord) {
            this.setState({ currentPage: 1 });
        }
    }

    render() {
        const { t } = this.props;
        const { currentPage, itemsPerPage } = this.state;

        // const indexOfLastItem = currentPage * itemsPerPage;
        // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        let currentData = this.props.data;

        // if (this.props.data && this.props.data.length > 0) {
        //     if (this.props.data.length < indexOfLastItem) {
        //         currentData = this.props.data;
        //     } else {
        //         currentData = this.props.data.slice(indexOfFirstItem, indexOfLastItem);
        //     }
        // }
        // const sortedData = currentData.sort((a, b) => {
        //     return (b.commisssion || 0) - (a.commisssion || 0);
        // });

        // const totalPages = Math.ceil(this.props.data.length / itemsPerPage);
        const totalPages = Math.ceil(this.props.totalRecord / itemsPerPage);

        return (
            <div>
                <div className="table-header d-flex align-items-center justify-content-between flex-wrap">
                    <h1>{t("SearchResults")}</h1>
                    <div className="table-header-search">
                        <label htmlFor="" className="d-none d-lg-block">
                            {t("Period")}:
                        </label>
                        <button
                            className={this.props.timeSearchOption === "yesterday" && "active"}
                            onClick={() => {
                                this.props.handleChangeTimeSearchOption("yesterday");
                                this.props.hanleClickselect("yesterday");
                                this.setState({ currentPage: 1 });
                            }}
                        >
                            {t("Yesterday")}
                        </button>
                        <button
                            className={this.props.timeSearchOption === "7days" && "active"}
                            onClick={() => {
                                this.props.handleChangeTimeSearchOption("7days");
                                this.props.hanleClickselect("7days");
                                this.setState({ currentPage: 1 });
                            }}
                        >
                            {t("Last7days")}
                        </button>
                        <button
                            className={this.props.timeSearchOption === "30days" && "active"}
                            onClick={() => {
                                this.props.handleChangeTimeSearchOption("30days");
                                this.props.hanleClickselect("30days");
                                this.setState({ currentPage: 1 });
                            }}
                        >
                            {t("Last30days")}
                        </button>
                        {/* <button
                            className={this.props.timeSearchOption === "all" && "active"}
                            onClick={() => {
                                this.props.handleChangeTimeSearchOption("all");
                                this.props.hanleClickselect("all");
                            }}
                        >
                            {t("All")}
                        </button> */}
                    </div>
                </div>
                <div className="search-result">
                    <div className="table-container">
                        <div className="scroll-wrapper">
                            <table
                                className="custom-table"
                                style={{
                                    tableLayout: "fixed",
                                }}
                            >
                                <thead>
                                <tr>
                                    <th
                                        className="position-sticky"
                                        style={{
                                            left: 0,
                                            backgroundColor: "#181A20",
                                            borderTopLeftRadius: "50px",
                                        }}
                                    >
                                        {t("Nickname")}
                                    </th>
                                    <th>{t("Rank")}</th>
                                    <th>{t("TotalKLGD")}</th>
                                    <th style={{ borderRight: "0px" }}>{t("HHAccepted")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {currentData?.map((item, index) => (
                                    <tr key={index}>
                                        <td
                                            className="position-sticky"
                                            style={{
                                                left: 0,
                                                backgroundColor: "#181A20",
                                            }}
                                        >
                                            <a
                                                href="#"
                                                className="nickname-link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.props.handleChooseUser(item);
                                                }}
                                            >
                                                {item?.username || "error"}
                                            </a>
                                        </td>
                                        <td>{this.getVipNumber2(item?.vip)}</td>
                                        <td>{item?.volume || 0}</td>
                                        <td>{item?.commisssion || 0}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div
                            className="pagination-container"
                            style={{
                                display: `${
                                    this.state?.data?.length < itemsPerPage ? "none" : "flex"
                                }`,
                            }}
                        >
                            {currentPage !== 1 && (
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => this.handlePageChange(currentPage - 1)}
                                >
                                    {"<"}
                                </button>
                            )}
                            {Array.from({ length: Math.min(5, totalPages) }, (_, index) => {
                                const pageNumber =
                                    currentPage <= 3 ? index + 1 : currentPage - 2 + index;
                                if (pageNumber > totalPages) return null;
                                return (
                                    <button
                                        key={index}
                                        className={`pagination-btn ${
                                            currentPage === pageNumber ? "active" : ""
                                        }`}
                                        onClick={() => this.handlePageChange(pageNumber)}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })}
                            {totalPages > 5 && currentPage <= totalPages - 3 && (
                                <>
                                    <span>...</span>
                                    <button
                                        className={`pagination-btn ${
                                            currentPage === totalPages ? "active" : ""
                                        }`}
                                        onClick={() => this.handlePageChange(totalPages)}
                                    >
                                        {totalPages}
                                    </button>
                                </>
                            )}
                            {totalPages !== 0 && currentPage !== totalPages && (
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => this.handlePageChange(currentPage + 1)}
                                >
                                    {">"}
                                </button>
                            )}
                            {!totalPages && <span>{t("NoData")}</span>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Table);